import "../assets/css/adminLogin.css"
import React,{useEffect ,useRef,useState} from "react";
import {animation, headerSet,showNavLink,} from "../Helper/CssHelper";
import { useHistory } from "react-router-dom"
import { useAuth } from "../Firebase/AuthContext";
import { Alert } from "react-bootstrap";

function AdminLogin() {
  const nameRef = useRef()
  const emailRef = useRef()
  const passwordRef = useRef()
  const { login } = useAuth()
  const [error, setError] = useState("")
  const [loading, setLoading] = useState(false)
  const history = useHistory()

  async function handleSubmit(e){
    e.preventDefault()

    try {
      setError("")
      setLoading(true)
      await login(emailRef.current.value, passwordRef.current.value)
      history.push("/Admin")
    } catch(error) {
      setError(error.message)
    }

    setLoading(false)
  }

  useEffect(() => {
    headerSet("Admin-Login | Justin Dsouza");
    showNavLink('home','admin-login-section')
    animation("admin-login-section");
  }, [])
  return (
    <div>
      <section id="admin-login-section" className="admin-login section-show">
        <div className="container">
          <div className="section-title">
          {error && <Alert variant="danger">{error}</Alert>}

            <h2>Login</h2>
            <p>Elemento Login</p>
          </div>

          <form
            onSubmit={handleSubmit}
            className="php-email-form mt-4"
          >
            <div className="row">
              <div className="col-md-6 form-group">
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  id="name"
                  placeholder="Your Name"
                  ref={nameRef}
                  required
                />
              </div>
              <div className="col-md-6 form-group mt-3 mt-md-0">
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  id="email"
                  placeholder="Your Email"
                  ref={emailRef}
                  required
                />
              </div>
            </div>
            <div className="form-group mt-3">
              <input
                type="password"
                className="form-control"
                name="password"
                id="password"
                placeholder="Enter Password"
                ref={passwordRef}
                required
              ></input>
            </div>
            <div className="my-3">
              <div className="loading">Loading</div>
              <div className="error-message"></div>
              <div className="sent-message">
                Logging you in please Wait
              </div>
            </div>
            <div className="text-center">
              <button type="submit" disabled={loading}>Login</button>
            </div>
          </form>
        </div>
      </section>
    </div>
  );
}

export default AdminLogin;
